
import React from 'react';

export const Recruitment: React.FC = () => {
  return (
    <section id="recruitment" className="py-16 sm:py-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">
            求人情報
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed break-words">
            一緒に働く仲間を募集しています。
            未経験者も歓迎！
            充実した研修制度でサポートいたします。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mb-12 sm:mb-16">
          {/* サービス提供責任者 */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg min-w-0">
            <div className="bg-pink-600 text-white px-3 sm:px-4 py-2 rounded-lg inline-block mb-4 sm:mb-6">
              <span className="text-base sm:text-lg font-semibold whitespace-nowrap">正社員募集</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">
              サービス提供責任者
            </h3>
            
            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">給与:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0 break-words">
                  月給 219,000円〜295,000円
                </div>
              </div>
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">勤務時間:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0 break-words">
                  8:00〜17:00 または 9:00〜18:00
                </div>
              </div>
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">休日:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0 break-words">
                  週休2日制、年間休日110日
                </div>
              </div>
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">応募資格:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0 break-words">
                  実務者研修修了（介護福祉士歓迎）
                </div>
              </div>
            </div>

            <div className="mb-6 sm:mb-8">
              <h4 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">仕事内容</h4>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">訪問介護業務</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">訪問介護計画書作成</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">介護職員のシフト管理</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">介護職員の指導・育成</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">担当者会議出席</span>
                </li>
              </ul>
            </div>

            <div className="mb-6 sm:mb-8">
              <h4 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">待遇・福利厚生</h4>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">賞与あり・昇給あり</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">資格取得支援制度</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">退職金制度あり</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0 break-words">マイカー通勤可能（無料駐車場あり）</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-pink-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">社会保険完備</span>
                </li>
              </ul>
            </div>
          </div>

          {/* 介護職員・ヘルパー */}
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg min-w-0">
            <div className="bg-green-600 text-white px-3 sm:px-4 py-2 rounded-lg inline-block mb-4 sm:mb-6">
              <span className="text-base sm:text-lg font-semibold whitespace-nowrap">正社員・パート募集</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">
              介護職員・ヘルパー
            </h3>
            
            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">給与:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0">
                  <div className="mb-1 break-words">
                    正社員: 月給 204,000円〜245,000円
                  </div>
                  <div className="break-words">パート: 時給 1,400円〜</div>
                </div>
              </div>
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">勤務時間:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0 break-words">シフト制（応相談）</div>
              </div>
              <div className="flex items-start min-w-0">
                <div className="w-20 sm:w-24 text-base sm:text-lg font-semibold text-gray-700 flex-shrink-0">応募資格:</div>
                <div className="text-base sm:text-lg text-gray-700 min-w-0 break-words">
                  初任者研修以上（無資格・未経験者も相談可）
                </div>
              </div>
            </div>

            <div className="mb-6 sm:mb-8">
              <h4 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">仕事内容</h4>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0 break-words">身体介護（入浴・排泄・食事介助等）</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0 break-words">生活援助（掃除・洗濯・買い物・調理等）</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">利用者様への見守り・声かけ</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">記録作成・報告</span>
                </li>
              </ul>
            </div>

            <div className="mb-6 sm:mb-8">
              <h4 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">こんな方を歓迎します</h4>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">人と接することが好きな方</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">やりがいを持って働きたい方</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">チームワークを大切にできる方</span>
                </li>
                <li className="flex items-start min-w-0">
                  <span className="text-green-600 mr-2 flex-shrink-0">•</span>
                  <span className="min-w-0">向上心のある方</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg mb-12 sm:mb-16">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center break-words">
            充実した職場環境
          </h3>
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-graduation-cap-fill text-pink-600 text-2xl sm:text-3xl"></i>
              </div>
              <h4 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2 sm:mb-3 break-words">
                充実した研修制度
              </h4>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
                現場研修が充実しているため、
                未経験の方でも安心して
                勤務できます。
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-award-fill text-pink-600 text-2xl sm:text-3xl"></i>
              </div>
              <h4 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2 sm:mb-3 break-words">
                資格取得応援
              </h4>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
                シフトの調整など、
                資格を取得するための
                サポート体制が整っています。
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-calendar-check-fill text-pink-600 text-2xl sm:text-3xl"></i>
              </div>
              <h4 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2 sm:mb-3 break-words">
                働きやすい環境
              </h4>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
                管理者が時間調整を率先して行うので、
                オンとオフのメリハリをつけた
                働き方が可能です。
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">エントリー方法</h3>
          <p className="text-lg sm:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed break-words">
            ご質問やエントリーをご希望の方は、
            お電話またはお問い合わせフォームより
            ご連絡ください。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a href="tel:024-563-7717" className="bg-pink-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-lg sm:text-xl font-semibold hover:bg-pink-700 transition-colors whitespace-nowrap">
              <i className="ri-phone-fill mr-2"></i>
              024-563-7717
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};
